import Svg from 'components/utilities/svg'

const EditIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Edit Icon</title>
    <path d="M19.3,8.925 L15.05,4.725 L16.45,3.325 C16.8333333,2.94166667 17.3043333,2.75 17.863,2.75 C18.421,2.75 18.8916667,2.94166667 19.275,3.325 L20.675,4.725 C21.0583333,5.10833333 21.2583333,5.571 21.275,6.113 C21.2916667,6.65433333 21.1083333,7.11666667 20.725,7.5 L19.3,8.925 Z M17.85,10.4 L7.25,21 L3,21 L3,16.75 L13.6,6.15 L17.85,10.4 Z" />
  </Svg>
)

EditIcon.displayName = 'Edit'

export default EditIcon
